export default {
  serverHost: process.env.REACT_APP_SERVER_HOST || "http://localhost:5000",
};
